import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBKrW1R_tCnZOVhPiJXRT0IdfVk7cpLmiY",
  authDomain: "tawq-notification-test.firebaseapp.com",
  projectId: "tawq-notification-test",
  storageBucket: "tawq-notification-test.firebasestorage.app",
  messagingSenderId: "564094802484",
  appId: "1:564094802484:web:8f688d1b90db90bd848861",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);